import { fetchAuthSession } from "aws-amplify/auth";
import { post, put } from "aws-amplify/api";
import { useMutation, useQueryClient } from "react-query";
import { INSURANCE_QUERY } from "./useProfileInsuranceQuery";

export const PostInsuranceMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (InsuranceFormInputs) => {
      const session = await fetchAuthSession();
      const { body } = await post({
        apiName: "pcmedapi",
        path: `/profile/insurance`,
        options: {
          headers: {
            Authorization: session.tokens.idToken.toString(),
          },
          body: InsuranceFormInputs,
        },
      }).response;
      return (await body?.json()) || {};
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: [INSURANCE_QUERY] });
    },
  });
};

export const PutInsuranceMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (InsuranceFormInputs) => {
      const session = await fetchAuthSession();
      const { body } = await put({
        apiName: "pcmedapi",
        path: `/profile/insurance`,
        options: {
          headers: {
            Authorization: session.tokens.idToken.toString(),
          },
          body: InsuranceFormInputs,
        },
      }).response;
      return await body.json();
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: [INSURANCE_QUERY] });
    },
  });
};
